import { useSelector } from "react-redux";
import Logistic from "../components/Logistic";

export const Shipping = () => {
    const user = useSelector((state) => state.user.user);

    return (
        <div className="container" style={{ paddingBottom: 50, paddingTop: 50 }} >
            <Logistic user={user} />
        </div>
    )
}